// extracted by mini-css-extract-plugin
module.exports = {"CoursesList__item":"CoursesList_CoursesList__item__2g2Vz","CoursesList__modal":"CoursesList_CoursesList__modal__3cvWx"};